module.exports = __webpack_public_path__ + "img/img_tanchuang@2x.bc479823.png";